module.exports = __webpack_public_path__ + "bradavice_7_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_7_after.jpg
// module id = 941
// module chunks = 0